// Multi-Media Filter Products Data
    export const multiMediaFilterProducts = {
      'multi-port-manual-softener-valve': {
        id: 'multi-port-manual-softener-valve',
        title: 'Multi-Port Manual Softener Valve',
        name: 'Multi-Port Manual Softener Valve',
        category: 'Multi-Media Filter',
        image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/ee6f2886e563c6df35520935aea0208e.png',
        shortDescription: 'Reliable and economical manual control valve for softener and filter systems.',
        description: 'The Multi-Port Manual Softener Valve is a durable and user-friendly control valve designed for residential and light commercial water softener and filtration systems. It allows for easy manual control of service,backwash,brine & slow rinse,brine refill,and fast rinse cycles.',
        longDescription: "Engineered for simplicity and reliability,the Multi-Port Manual Softener Valve provides an economical solution for managing water treatment systems. Its robust construction ensures long-lasting performance,while the intuitive lever-action handle makes it easy for users to cycle through regeneration or backwash steps. This valve is ideal for applications where automatic regeneration is not required or desired,offering full control over the system's operation.",
        features: [
          'Manual control for easy operation',
          'Side mount and top mount options available',
          'Suitable for softener and filter applications',
          'Durable,corrosion-resistant materials',
          'Simple lever action for cycle selection',
          'Economical and reliable solution'
        ],
        applications: [
          'Residential water softeners',
          'Light commercial water softeners',
          'Point-of-entry (POE) filtration systems',
          'Iron and manganese removal systems',
          'Carbon filtration systems'
        ],
        specifications: {
          'Valve Material': 'High-strength Plastic / ABS',
          'Inlet/Outlet': '1" or 3/4" (model dependent)',
          'Drain Connection': '1/2"',
          'Brine Line Connection': '3/8"',
          'Mounting Type': 'Top Mount / Side Mount',
          'Max Flow Rate': '4.5 m³/h'
        },
        technicalData: {
          'Model Specifications (Softener)': [
            { 'Model': 'F64A', 'Inlet/Outlet': '1"', 'Drain': '1/2"', 'Brine Line': '3/8"', 'Base': '2.5"-8NPSM', 'Riser Pipe': '1.05" OD', 'Max Flow Rate': '4 m³/h', 'Tank Size': '6" - 12"' },
            { 'Model': 'F56A', 'Inlet/Outlet': '1"', 'Drain': '1/2"', 'Brine Line': '3/8"', 'Base': '2.5"-8NPSM', 'Riser Pipe': '1.05" OD', 'Max Flow Rate': '2 m³/h', 'Tank Size': '6" - 10"' }
          ],
          'Model Specifications (Filter)': [
            { 'Model': 'F64B', 'Inlet/Outlet': '1"', 'Drain': '1/2"', 'Base': '2.5"-8NPSM', 'Riser Pipe': '1.05" OD', 'Max Flow Rate': '4 m³/h', 'Tank Size': '6" - 12"' },
            { 'Model': 'F56E', 'Inlet/Outlet': '1"', 'Drain': '1/2"', 'Base': '2.5"-8NPSM', 'Riser Pipe': '1.05" OD', 'Max Flow Rate': '2 m³/h', 'Tank Size': '6" - 10"' }
          ]
        }
      },
      'multi-port-manual-filter-valve': {
        id: 'multi-port-manual-filter-valve',
        title: 'Multi-Port Manual Filter Valve',
        name: 'Multi-Port Manual Filter Valve',
        category: 'Multi-Media Filter',
        image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/f39716561652bca664f108991de4184a.jpg',
        shortDescription: 'Versatile manual control valve for various water filtration systems.',
        description: 'A manual multi-port control valve for filter systems,available in multiple configurations to match different housing sizes and flow requirements. It is a reliable and cost-effective solution for managing backwash and rinse cycles.',
        longDescription: "The Multi-Port Manual Filter Valve is designed for flexibility and reliability in water filtration systems. With various models available,it can be matched with 10\" and 20\" housings,and supports different connection sizes from 1/2\" to 2\". Side-mounted connectors are available for 2-1/2\" and 4\" ports. Please note that water treatment capacity is dependent on flow speed,inlet pressure,and filter media. The parameters below are for reference. \n\nNotes:\n① M—Male Thread,F—Female Thread,OD—Outer Diameter\n② 2-1/2\" and 4\" side-mounted connectors available. The TOP and BOTTOM size of 2-1/2\" one is 1\",the size of 4\" one is 2\".\n③ TM.F56B is matching with 10\" housing.\n④ TM.F56C is matching with 20\" housing.",
        features: [
          'Multiple models for different flow capacities',
          'Inlet/Outlet sizes from 1/2" to 2"',
          'Designed to match with standard 10" and 20" filter housings',
          'Side-mounted connector options available',
          'Durable construction for long service life',
          'Manual control for simple operation'
        ],
        applications: [
          'Multi-media filtration',
          'Activated carbon filters',
          'Sand filters',
          'Iron removal filters',
          'General water pre-filtration'
        ],
        specifications: {
          'Connection Types': 'Female Thread (F),Male Thread (M),Outer Diameter (OD)',
          'Riser Pipe Sizes': '1.05" OD,1.5" D-GB,1" D-GB,Inserting Mode',
          'Base Connections': 'NPSM,UN,M82',
          'Housing Compatibility': '10" and 20" housings supported'
        },
        technicalData: {
          'Connection Size & Capacity': [
            { 'Model': 'TM.F56A', 'Inlet/Outlet': '1" F', 'Drain Outlet': '1" F', 'Base': '2-1/2" - 8 NPSM', 'Riser Pipe': '1.05" OD (26.7mm)', 'Maximum Water Capacity m³/h': '4.5' },
            { 'Model': 'TM.F56B', 'Inlet/Outlet': '3/4" or 1/2" F', 'Drain Outlet': '3/4" or 1/2" F', 'Base': 'Matching With 10" Housing', 'Riser Pipe': '1.05" OD (26.7mm)', 'Maximum Water Capacity m³/h': '0.5 - 1' },
            { 'Model': 'TM.F56C', 'Inlet/Outlet': '3/4" or 1/2" F', 'Drain Outlet': '3/4" or 1/2" F', 'Base': 'Matching With 20" Housing', 'Riser Pipe': '1.05" OD (26.7mm)', 'Maximum Water Capacity m³/h': '0.5 - 1' },
            { 'Model': 'TM.F56D', 'Inlet/Outlet': '2" F', 'Drain Outlet': '1 - 1/2" F', 'Base': '4" - 8 UN', 'Riser Pipe': '1.5" D - GB (50mm)', 'Maximum Water Capacity m³/h': '10' },
            { 'Model': 'TM.F56E', 'Inlet/Outlet': '3/4" or 1/2" F', 'Drain Outlet': '3/4" or 1/2" F', 'Base': '2-1/2" - 8 NPSM', 'Riser Pipe': '1.05" OD (26.7mm)', 'Maximum Water Capacity m³/h': '2' },
            { 'Model': 'TM.F56F', 'Inlet/Outlet': '1" F', 'Drain Outlet': '1" F', 'Base': '2-1/2" - 8 NPSM', 'Riser Pipe': '1" D - GB (32mm)', 'Maximum Water Capacity m³/h': '6' },
            { 'Model': 'TM.F52', 'Inlet/Outlet': '1/2" F', 'Drain Outlet': '1/2" F', 'Base': 'M82 x 3', 'Riser Pipe': 'Inserting Mode (16.5mm)', 'Maximum Water Capacity m³/h': '0.5 - 1' }
          ]
        }
      },
      'multi-port-automatic-softener-valve': {
        id: 'multi-port-automatic-softener-valve',
        title: 'Multi-Port Automatic Softener Valve',
        name: 'Multi-Port Automatic Softener Valve',
        category: 'Multi-Media Filter',
        image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/694559f5ba74f0d5ed5e6927cd4ffa8c.jpg',
        shortDescription: 'Automatic multi-port control valve for softener systems,ensuring efficient regeneration and reliable operation.',
        description: 'The Multi-Port Automatic Softener Valve offers advanced control for water softening systems. It automates the regeneration process based on time or flow,ensuring a continuous supply of soft water with minimal user intervention.',
        longDescription: 'This control valve is engineered for reliability and ease of use. It features a robust design with multiple models to fit various tank sizes and flow requirements. The automatic controller can be set for different regeneration modes (Down-Flow or UP-Flow) and count modes (Day or Hour),providing flexibility for residential and commercial applications. The clear display and simple controls make setup and operation straightforward.',
        features: [
          'Automatic regeneration based on time or flow',
          'Multiple models for various system sizes',
          'Down-Flow and UP-Flow regeneration modes',
          'Durable,corrosion-resistant materials',
          'Easy-to-use controller with clear display',
          'Manual hand wheel option on some models'
        ],
        applications: [
          'Residential water softeners',
          'Commercial water softening systems',
          'Industrial pre-treatment',
          'Boiler feed water systems'
        ],
        specifications: {
          'Controller Type': 'Time Type',
          'Transformer Input': '100 ~ 240 V / 50 ~ 60 Hz',
          'Suited Pressure': '0.15 - 0.6 Mpa',
          'Suited Temperature': '5 ~ 45 °C'
        },
        technicalData: {
          'Control Valve Models': [
            { 'Model': 'TM.F63B1', 'Inlet/Outlet': '1" M', 'Drain Outlet': '1/2" M', 'Brine Tank Connector': '3/8" M', 'Base': '2-1/2"-8NPSM', 'Riser Pipe': '1.05" OD (26.7mm)', 'Count Mode For Running': 'Day', 'Max Water Capacity m³/h': '4.5', 'Manual Hand Wheel': 'Yes', 'Regeneration Mode': 'Down-Flow' },
            { 'Model': 'TM.F63B2', 'Inlet/Outlet': '1" M', 'Drain Outlet': '1/2" M', 'Brine Tank Connector': '3/8" M', 'Base': '2-1/2"-8NPSM', 'Riser Pipe': '1.05" OD (26.7mm)', 'Count Mode For Running': 'Hour', 'Max Water Capacity m³/h': '4.5', 'Manual Hand Wheel': 'Yes', 'Regeneration Mode': 'Down-Flow' },
            { 'Model': 'TM.F65B1', 'Inlet/Outlet': '3/4" F', 'Drain Outlet': '1/2" M', 'Brine Tank Connector': '3/8" M', 'Base': '2-1/2"-8NPSM', 'Riser Pipe': '1.05" OD (26.7mm)', 'Count Mode For Running': 'Day', 'Max Water Capacity m³/h': '2', 'Manual Hand Wheel': 'No', 'Regeneration Mode': 'Down-Flow' },
            { 'Model': 'TM.F65B2', 'Inlet/Outlet': '3/4" F', 'Drain Outlet': '1/2" M', 'Brine Tank Connector': '3/8" M', 'Base': '2-1/2"-8NPSM', 'Riser Pipe': '1.05" OD (26.7mm)', 'Count Mode For Running': 'Hour', 'Max Water Capacity m³/h': '2', 'Manual Hand Wheel': 'No', 'Regeneration Mode': 'Down-Flow' },
            { 'Model': 'TM.F68A1', 'Inlet/Outlet': '1" M', 'Drain Outlet': '1/2" M', 'Brine Tank Connector': '3/8" M', 'Base': '2-1/2"-8NPSM', 'Riser Pipe': '1.05" OD (26.7mm)', 'Count Mode For Running': 'Day', 'Max Water Capacity m³/h': '4.5', 'Manual Hand Wheel': 'Yes', 'Regeneration Mode': 'UP-Flow' },
            { 'Model': 'TM.F68A2', 'Inlet/Outlet': '1" M', 'Drain Outlet': '1/2" M', 'Brine Tank Connector': '3/8" M', 'Base': '2-1/2"-8NPSM', 'Riser Pipe': '1.05" OD (26.7mm)', 'Count Mode For Running': 'Hour', 'Max Water Capacity m³/h': '4.5', 'Manual Hand Wheel': 'Yes', 'Regeneration Mode': 'UP-Flow' },
            { 'Model': 'TM.F69A1', 'Inlet/Outlet': '3/4" F', 'Drain Outlet': '1/2" M', 'Brine Tank Connector': '3/8" M', 'Base': '2-1/2"-8NPSM', 'Riser Pipe': '1.05" OD (26.7mm)', 'Count Mode For Running': 'Day', 'Max Water Capacity m³/h': '2', 'Manual Hand Wheel': 'No', 'Regeneration Mode': 'UP-Flow' },
            { 'Model': 'TM.F69A2', 'Inlet/Outlet': '3/4" F', 'Drain Outlet': '1/2" M', 'Brine Tank Connector': '3/8" M', 'Base': '2-1/2"-8NPSM', 'Riser Pipe': '1.05" OD (26.7mm)', 'Count Mode For Running': 'Hour', 'Max Water Capacity m³/h': '2', 'Manual Hand Wheel': 'No', 'Regeneration Mode': 'UP-Flow' },
            { 'Model': 'TM.F74A1', 'Inlet/Outlet': '2" M', 'Drain Outlet': '1" M', 'Brine Tank Connector': '1/2" M', 'Base': '4" - 8 UN', 'Riser Pipe': '1.5" D-GB (50mm)', 'Count Mode For Running': 'Day', 'Max Water Capacity m³/h': '10', 'Manual Hand Wheel': 'No', 'Regeneration Mode': 'Down-Flow' },
            { 'Model': 'TM.F74A2', 'Inlet/Outlet': '2" M', 'Drain Outlet': '1" M', 'Brine Tank Connector': '1/2" M', 'Base': '4" - 8 UN', 'Riser Pipe': '1.5" D-GB (50mm)', 'Count Mode For Running': 'Hour', 'Max Water Capacity m³/h': '10', 'Manual Hand Wheel': 'No', 'Regeneration Mode': 'Down-Flow' },
            { 'Model': 'TM.F63B3', 'Inlet/Outlet': '1" M', 'Drain Outlet': '1/2" M', 'Brine Tank Connector': '3/8" M', 'Base': '2-1/2"-8NPSM', 'Riser Pipe': '1.05" OD (26.7mm)', 'Max Water Capacity m³/h': '4.5', 'Manual Hand Wheel': 'Yes', 'Regeneration Mode': 'Down-Flow' },
            { 'Model': 'TM.F65B3', 'Inlet/Outlet': '3/4" F', 'Drain Outlet': '1/2" M', 'Brine Tank Connector': '3/8" M', 'Base': '2-1/2"-8NPSM', 'Riser Pipe': '1.05" OD (26.7mm)', 'Max Water Capacity m³/h': '2', 'Manual Hand Wheel': 'No', 'Regeneration Mode': 'Down-Flow' },
            { 'Model': 'TM.F68A3', 'Inlet/Outlet': '1" M', 'Drain Outlet': '1/2" M', 'Brine Tank Connector': '3/8" M', 'Base': '2-1/2"-8NPSM', 'Riser Pipe': '1.05" OD (26.7mm)', 'Max Water Capacity m³/h': '4.5', 'Manual Hand Wheel': 'Yes', 'Regeneration Mode': 'UP-Flow' },
            { 'Model': 'TM.F69A3', 'Inlet/Outlet': '3/4" F', 'Drain Outlet': '1/2" M', 'Brine Tank Connector': '3/8" M', 'Base': '2-1/2"-8NPSM', 'Riser Pipe': '1.05" OD (26.7mm)', 'Max Water Capacity m³/h': '2', 'Manual Hand Wheel': 'No', 'Regeneration Mode': 'UP-Flow' },
            { 'Model': 'TM.F74A3', 'Inlet/Outlet': '2" M', 'Drain Outlet': '1" M', 'Brine Tank Connector': '1/2" M', 'Base': '4" - 8 UN', 'Riser Pipe': '1.5" D-GB (50mm)', 'Max Water Capacity m³/h': '10', 'Manual Hand Wheel': 'No', 'Regeneration Mode': 'Down-Flow' }
          ]
        }
      },
      'multi-port-automatic-filter-valve': {
        id: 'multi-port-automatic-filter-valve',
        title: 'Multi-Port Automatic Filter Valve',
        name: 'Multi-Port Automatic Filter Valve',
        category: 'Multi-Media Filter',
        image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/955495052ec7c622ee10db7becbba261.jpg',
        shortDescription: 'Automatic control valve for filter systems,featuring time-based backwashing for efficient and hassle-free operation.',
        description: 'The Multi-Port Automatic Filter Valve automates the backwash and rinse cycles for filtration systems. It can be programmed to regenerate based on time (Day or Hour),ensuring consistent water quality with minimal manual intervention.',
        longDescription: 'This automatic filter valve simplifies the operation of multi-media filters,sand filters,and carbon filters by automating the backwash process. Its reliable controller ensures that the filtration media is cleaned regularly,maintaining optimal performance and extending media life. With various models available to match different flow rates and connection sizes,it offers a flexible and efficient solution for both residential and commercial water treatment systems.',
        features: [
          'Automatic backwash based on time (Day or Hour mode)',
          'Multiple models for various flow rates and system sizes',
          'Durable,corrosion-resistant construction',
          'Easy-to-program controller',
          'Manual hand wheel option on some models',
          'Reduces manual maintenance and ensures consistent filter performance'
        ],
        applications: [
          'Multi-media filtration',
          'Sand filters',
          'Activated carbon filters',
          'Iron and manganese removal systems',
          'Pre-filtration for RO systems'
        ],
        specifications: {
          'Controller Mode': 'Time Type',
          'Transformer Input': '100-240V / 50-60Hz',
          'Suited Pressure': '0.1 - 0.6 MPa',
          'Suited Temperature': '5 - 45 °C'
        },
        technicalData: {
          'Control Valve Models': [
            { 'Model': 'TM.F67B1', 'Inlet/Outlet': '1" F', 'Drain Outlet': '1" F', 'Base': '2 - 1/2" - 8 NPSM', 'Riser Pipe': '1.05" OD (26.7mm)', 'Running mode': 'Day', 'Maximum Water Capacity m³/h': '6', 'Wheel': 'Yes' },
            { 'Model': 'TM.F67B2', 'Inlet/Outlet': '1" F', 'Drain Outlet': '1" F', 'Base': '2 - 1/2" - 8 NPSM', 'Riser Pipe': '1.05" OD (26.7mm)', 'Running mode': 'Hour', 'Maximum Water Capacity m³/h': '6', 'Wheel': 'Yes' },
            { 'Model': 'TM.F71B1', 'Inlet/Outlet': '3/4" M', 'Drain Outlet': '3/4" M', 'Base': '2 - 1/2" - 8 NPSM', 'Riser Pipe': '1.05" OD (26.7mm)', 'Running mode': 'Day', 'Maximum Water Capacity m³/h': '2', 'Wheel': 'No' },
            { 'Model': 'TM.F71B2', 'Inlet/Outlet': '3/4" M', 'Drain Outlet': '3/4" M', 'Base': '2 - 1/2" - 8 NPSM', 'Riser Pipe': '1.05" OD (26.7mm)', 'Running mode': 'Hour', 'Maximum Water Capacity m³/h': '2', 'Wheel': 'No' },
            { 'Model': 'TM.F75A1', 'Inlet/Outlet': '2" M', 'Drain Outlet': '2" M', 'Base': '4" - 8UN', 'Riser Pipe': '1.5" D-GB(50mm)', 'Running mode': 'Day', 'Maximum Water Capacity m³/h': '10', 'Wheel': 'No' },
            { 'Model': 'TM.F75A2', 'Inlet/Outlet': '2" M', 'Drain Outlet': '2" M', 'Base': '4" - 8UN', 'Riser Pipe': '1.5" D-GB(50mm)', 'Running mode': 'Hour', 'Maximum Water Capacity m³/h': '10', 'Wheel': 'No' }
          ]
        }
      },
      'water-distributor': {
        id: 'water-distributor',
        title: 'Water Distributor',
        name: 'Water Distributor',
        category: 'Multi-Media Filter',
        image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/dbc45b6bfca822250189c396a97aeb0b.jpg',
        shortDescription: 'Essential components designed for uniform flow distribution in media filters and softeners.',
        description: 'Water distributors are crucial for the proper functioning of media filters,softeners,and ion exchange systems,ensuring even flow of water through the media bed for optimal performance.',
        longDescription: 'These distributors and laterals are engineered to provide uniform distribution of water during both service and backwash cycles. Constructed from durable,corrosion-resistant materials like ABS and PP,they prevent media loss and ensure the entire filter bed is utilized efficiently. We offer a wide variety of top and bottom distributors,as well as hub and lateral systems,to fit various tank sizes and valve configurations.',
        features: [
          'Ensures uniform flow distribution during service and backwash',
          'Durable,corrosion-resistant plastic construction (ABS,PP)',
          'Wide variety of models to fit different tank sizes and valves',
          'Includes top distributors,bottom distributors,and hub & lateral systems',
          'Prevents loss of filter media',
          'Optimizes filtration and regeneration efficiency'
        ],
        applications: [
          'Multi-media filters',
          'Water softeners',
          'Activated carbon filters',
          'Sand filters',
          'Ion exchange systems'
        ],
        specifications: {
          'Material': 'High-strength Plastic (ABS,PP)',
          'Types': 'Top distributors,bottom distributors,hub & lateral systems',
          'Connection Sizes': 'Varies by model (e.g.,1",2")',
          'Base Sizes': 'Varies by model (e.g.,2.5",4")'
        },
        technicalData: {
          'Available Models': [
            { 'Model': 'F0601', 'Description': 'Top/Bottom Distributor' },
            { 'Model': 'F0602', 'Description': 'Top/Bottom Distributor' },
            { 'Model': 'F0603,F0613', 'Description': 'Top Strainer' },
            { 'Model': 'F0604,F0614', 'Description': 'Top Strainer' },
            { 'Model': 'F182(L)', 'Description': 'Distributor Tube' },
            { 'Model': 'F182X', 'Description': 'Distributor Tube (Closed End)' },
            { 'Model': 'F8801', 'Description': 'Valve Head,Base 2.5",In/Out 1"' },
            { 'Model': 'F8802', 'Description': 'Valve Head,Base 4",In/Out 2"' },
            { 'Model': 'FU6370,FU6450,FU6600,FU6700', 'Description': 'Hub & Lateral System' },
            { 'Model': 'F5671,F5672', 'Description': 'Side-mount Distributor' },
            { 'Model': 'FD6370,FD6450,FD6600,FD6700', 'Description': 'Hub & Lateral System with Elbow' },
            { 'Model': 'F173,F175', 'Description': 'Top Mount Distributor' },
            { 'Model': 'FD5674,FD5675', 'Description': 'Hub & Lateral System' }
          ]
        }
      },
      'frp-tank': {
        id: 'frp-tank',
        title: 'Fiberglass Reinforced Plastic (FRP) Tank',
        name: 'Fiberglass Reinforced Plastic (FRP) Tank',
        category: 'Multi-Media Filter',
        image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/5592d07875bc9bafd4fa068fb355983e.jpg',
        shortDescription: 'High-quality fiberglass reinforced plastic tanks for water softeners,filters,and storage.',
        description: 'Durable and corrosion-resistant FRP tanks designed for residential and commercial water treatment applications. Features a seamless polyethylene inner liner and a fiberglass-wound outer shell.',
        longDescription: 'These FRP tanks are a reliable and cost-effective solution for water softeners,multimedia filters,carbon filters,and other water treatment systems. The seamless,one-piece PE liner prevents leaks,while the continuous fiberglass reinforcement provides superior strength and durability. They are designed to withstand harsh environmental conditions and are suitable for a wide range of water treatment needs.',
        features: [
          'Seamless PE or PP inner liner for corrosion resistance',
          'Fiberglass wound outer shell for high strength',
          'Completely rustproof and corrosion-resistant',
          'Lightweight and easy to handle',
          'Various sizes and configurations available',
          'Suitable for residential and commercial applications'
        ],
        applications: [
          'Water softeners',
          'Multi-media filters',
          'Carbon filters',
          'Sand filters',
          'Water storage'
        ],
        specifications: {
          'Shell Layer': 'Fiber Glass',
          'Liner Material': 'PE or PP',
          'MAX. Test Pressure': '150psi',
          'MAX. Working Pressure': '100psi',
          'Temperature Range': '1-49℃',
          'MAX. Vacuum': '5″Hg(127mm Hg)'
        },
        technicalData: {
          'Model Specifications': [
            { 'Model': '818', 'Dia.X Height (mm)': '200*450', 'TOP Open': '2.5" Thread', 'Bottom Open': 'N/A', 'TOP Distributor': '-', 'Bottom Distributor': '-', 'Mounting Mode': 'TOP', 'Design Flux (LPM)': '0 ~ 3.5' },
            { 'Model': '835', 'Dia.X Height (mm)': '200*875', 'TOP Open': '2.5" Thread', 'Bottom Open': 'N/A', 'TOP Distributor': '-', 'Bottom Distributor': '-', 'Mounting Mode': 'TOP', 'Design Flux (LPM)': '3.5 ~ 8.5' },
            { 'Model': '844', 'Dia.X Height (mm)': '200*1200', 'TOP Open': '2.5" Thread', 'Bottom Open': 'N/A', 'TOP Distributor': '-', 'Bottom Distributor': '-', 'Mounting Mode': 'TOP', 'Design Flux (LPM)': '3.5 ~ 8.5' },
            { 'Model': '1035', 'Dia.X Height (mm)': '250*875', 'TOP Open': '2.5" Thread', 'Bottom Open': 'N/A', 'TOP Distributor': 'F0601', 'Bottom Distributor': 'F0602', 'Mounting Mode': 'TOP', 'Design Flux (LPM)': '8.5 ~ 16.5' },
            { 'Model': '1054', 'Dia.X Height (mm)': '240*1400', 'TOP Open': '2.5" Thread', 'Bottom Open': 'N/A', 'TOP Distributor': 'F0603', 'Bottom Distributor': 'F0604', 'Mounting Mode': 'TOP', 'Design Flux (LPM)': '10 ~ 25' },
            { 'Model': '1252', 'Dia.X Height (mm)': '300*1350', 'TOP Open': '2.5" Thread', 'Bottom Open': 'N/A', 'TOP Distributor': 'F0613', 'Bottom Distributor': 'F0614', 'Mounting Mode': 'TOP', 'Design Flux (LPM)': '26 ~ 36' },
            { 'Model': '1265', 'Dia.X Height (mm)': '300*1650', 'TOP Open': '2.5" Thread', 'Bottom Open': 'N/A', 'TOP Distributor': '-', 'Bottom Distributor': '-', 'Mounting Mode': 'TOP', 'Design Flux (LPM)': '33 ~ 41' },
            { 'Model': '1354', 'Dia.X Height (mm)': '325*1400', 'TOP Open': '2.5" Thread', 'Bottom Open': 'N/A', 'TOP Distributor': '-', 'Bottom Distributor': '-', 'Mounting Mode': 'TOP', 'Design Flux (LPM)': '33 ~ 41' },
            { 'Model': '1465', 'Dia.X Height (mm)': '350*1650', 'TOP Open': '2.5" Thread', 'Bottom Open': 'N/A', 'TOP Distributor': '-', 'Bottom Distributor': '-', 'Mounting Mode': 'TOP', 'Design Flux (LPM)': '40 ~ 50' },
            { 'Model': '1665', 'Dia.X Height (mm)': '400*1650', 'TOP Open': '2.5" Thread', 'Bottom Open': 'N/A', 'TOP Distributor': '-', 'Bottom Distributor': '-', 'Mounting Mode': 'TOP', 'Design Flux (LPM)': '53 ~ 75' },
            { 'Model': '1865', 'Dia.X Height (mm)': '460*1650', 'TOP Open': '2.5" Thread', 'Bottom Open': 'N/A', 'TOP Distributor': 'F182(L)', 'Bottom Distributor': 'F182X / FU6370', 'Mounting Mode': 'TOP', 'Design Flux (LPM)': '75 ~ 83' },
            { 'Model': '2069', 'Dia.X Height (mm)': '500*1750', 'TOP Open': '4" Thread', 'Bottom Open': '4" Thread', 'TOP Distributor': 'F182(L) / F5671 / F5672', 'Bottom Distributor': 'F182X / FU6370 / FD6370', 'Mounting Mode': 'TOP/SIDE', 'Design Flux (LPM)': '75 ~ 100' },
            { 'Model': '2472', 'Dia.X Height (mm)': '600*1850', 'TOP Open': '4" Thread', 'Bottom Open': '4" Thread', 'TOP Distributor': 'F182(L) / F5671 / F5672', 'Bottom Distributor': 'F182X / FU6450 / FD6450', 'Mounting Mode': 'TOP/SIDE', 'Design Flux (LPM)': '100 ~ 135' },
            { 'Model': '3072', 'Dia.X Height (mm)': '750*1850', 'TOP Open': '4" Thread', 'Bottom Open': '4" Thread', 'TOP Distributor': 'F182(L) / F5671 / F5672', 'Bottom Distributor': 'F182X / FU6600 / FD6600', 'Mounting Mode': 'TOP/SIDE', 'Design Flux (LPM)': '120 ~ 203' },
            { 'Model': '3672', 'Dia.X Height (mm)': '900*1850', 'TOP Open': '4" Thread', 'Bottom Open': '4" Thread', 'TOP Distributor': 'F182(L) / F5671 / F5672', 'Bottom Distributor': 'F182X / FU6700 / FD6700', 'Mounting Mode': 'TOP/SIDE', 'Design Flux (LPM)': '220 ~ 270' },
            { 'Model': '4072', 'Dia.X Height (mm)': '1000*1850', 'TOP Open': '6" Flange', 'Bottom Open': '6" Flange', 'TOP Distributor': 'F173 / F175', 'Bottom Distributor': 'FD5674', 'Mounting Mode': 'TOP/SIDE', 'Design Flux (LPM)': '280 ~ 380' },
            { 'Model': '4872', 'Dia.X Height (mm)': '1200*1850', 'TOP Open': '6" Flange', 'Bottom Open': '6" Flange', 'TOP Distributor': 'F173 / F175', 'Bottom Distributor': 'FD5675', 'Mounting Mode': 'SIDE', 'Design Flux (LPM)': '365 ~ 450' },
            { 'Model': '4896', 'Dia.X Height (mm)': '1200*2400', 'TOP Open': '6" Flange', 'Bottom Open': '6" Flange', 'TOP Distributor': 'F173 / F175', 'Bottom Distributor': 'FD5675', 'Mounting Mode': 'SIDE', 'Design Flux (LPM)': '465 ~ 635' }
          ]
        }
      },
      'ion-exchange-resin': {
        id: 'ion-exchange-resin',
        title: 'Ion Exchange Resin',
        name: 'Ion Exchange Resin',
        category: 'Multi-Media Filter',
        image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/ad5e58c3ec2204eb07497c3d5434b6f7.jpg',
        shortDescription: 'High-quality ion exchange resins for water softening,deionization,and purification.',
        description: 'A range of cation and anion exchange resins for various water treatment applications,including softening (e.g.,001x7 Na+),demineralization,and selective ion removal.',
        longDescription: 'Our ion exchange resins are high-purity,high-capacity spherical beads designed for a wide array of water treatment processes. This includes strong acid cation resins (like the 001x7 Na+ type) for effective water softening by removing calcium and magnesium ions,as well as various anion and mixed-bed resins for deionization and ultrapure water production. They are suitable for use in industrial,commercial,and residential applications,providing reliable performance and long service life.',
        features: [
          'High-purity,high-capacity resin beads',
          'Available as strong/weak acid cation and strong/weak base anion resins',
          'Effective for water softening,deionization,and dealkalization',
          'Uniform particle size for low pressure drop and superior kinetics',
          'Excellent chemical and physical stability',
          'Suitable for industrial,commercial,and residential use'
        ],
        applications: [
          'Water softening (residential and industrial)',
          'Demineralization and deionization',
          'Ultrapure water production',
          'Condensate polishing',
          'Selective removal of contaminants (e.g.,nitrates,heavy metals)',
          'Chemical processing'
        ],
        specifications: {
          'Type': 'Strong Acid Cation,Weak Acid Cation,Strong Base Anion,Weak Base Anion,Mixed Bed',
          'Ionic Form': 'Na+ (Sodium),H+ (Hydrogen),Cl- (Chloride),OH- (Hydroxide)',
          'Matrix': 'Polystyrene crosslinked with DVB',
          'Particle Size': '0.3 - 1.2 mm',
          'Total Capacity': 'Varies by type (e.g.,≥1.9 eq/L for 001x7 Na+)',
          'Packaging': '25 Liters / Bag'
        },
        technicalData: {
          'Common Resin Types': [
            { 'Type': '001x7', 'Description': 'Strong Acid Cation (Gel Type)', 'Ionic Form': 'Na+', 'Application': 'Softening' },
            { 'Type': '201x7', 'Description': 'Strong Base Anion (Gel Type)', 'Ionic Form': 'Cl-', 'Application': 'Deionization' },
            { 'Type': 'D113', 'Description': 'Weak Acid Cation (Macroporous)', 'Ionic Form': 'H+', 'Application': 'Dealkalization' },
            { 'Type': 'MB-Series', 'Description': 'Mixed Bed Resin', 'Ionic Form': 'H+/OH-', 'Application': 'Ultrapure Water' }
          ]
        }
      },
      'brine-tank': {
        id: 'brine-tank',
        title: 'Brine Tank',
        name: 'Brine Tank',
        category: 'Multi-Media Filter',
        image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/f36c496b6a31a4339add144becdec686.jpg',
        shortDescription: 'Durable polyethylene (PE) brine tanks for water softener regeneration, available in various capacities from 15L to 2000L.',
        description: 'High-quality brine tanks designed for use with water softening systems. These tanks hold the salt solution (brine) required for regenerating the ion exchange resin in softeners.',
        longDescription: 'Our brine tanks are manufactured from high-quality, durable polyethylene (PE) material, ensuring long service life and resistance to corrosive salt solutions. They are an essential component of any water softening system, providing a reliable reservoir for the brine used in the regeneration cycle. Available in a wide range of sizes, from compact 15L models to large 2000L tanks, they can be matched to any residential or commercial softener system. Each tank can be equipped with a corresponding brine valve and well assembly for proper operation.',
        features: [
          'Made from durable, corrosion-resistant Polyethylene (PE) material',
          'Wide range of capacities available (15L to 2000L)',
          'Designed for water softener regeneration',
          'Compatible with standard brine valve assemblies',
          'Seamless, one-piece construction for leak-proof performance'
        ],
        applications: [
          'Residential water softeners',
          'Commercial water softening systems',
          'Industrial water treatment',
          'Brine storage for ion exchange systems'
        ],
        specifications: {
          'Tank Material': 'Polyethylene (PE)',
          'Available Capacities': '15L to 2000L',
          'Included Components': 'Tank, lid, brine well, brine valve assembly'
        },
        technicalData: {
          'Brine Tank Specifications': [
            { 'Capacity (L)': '15L', 'Diameter (mm)': 'Φ210', 'Net Height (mm)': '420', 'Total Height (mm)': '460' },
            { 'Capacity (L)': '25L', 'Diameter (mm)': 'Φ240', 'Net Height (mm)': '460', 'Total Height (mm)': '500' },
            { 'Capacity (L)': '60L', 'Diameter (mm)': 'Φ340', 'Net Height (mm)': '630', 'Total Height (mm)': '690' },
            { 'Capacity (L)': '100L', 'Diameter (mm)': 'Φ390', 'Net Height (mm)': '790', 'Total Height (mm)': '850' },
            { 'Capacity (L)': '150L', 'Diameter (mm)': 'Φ500', 'Net Height (mm)': '820', 'Total Height (mm)': '880' },
            { 'Capacity (L)': '200L', 'Diameter (mm)': 'Φ500', 'Net Height (mm)': '930', 'Total Height (mm)': '1000' },
            { 'Capacity (L)': '300L', 'Diameter (mm)': 'Φ630', 'Net Height (mm)': '1090', 'Total Height (mm)': '1190' },
            { 'Capacity (L)': '500L', 'Diameter (mm)': 'Φ770', 'Net Height (mm)': '1140', 'Total Height (mm)': '1290' },
            { 'Capacity (L)': '800L', 'Diameter (mm)': 'Φ920', 'Net Height (mm)': '1170', 'Total Height (mm)': '1350' },
            { 'Capacity (L)': '1000L', 'Diameter (mm)': 'Φ1040', 'Net Height (mm)': '1220', 'Total Height (mm)': '1400' },
            { 'Capacity (L)': '1500L', 'Diameter (mm)': 'Φ1490', 'Net Height (mm)': '1200', 'Total Height (mm)': '1400' },
            { 'Capacity (L)': '2000L', 'Diameter (mm)': 'Φ1490', 'Net Height (mm)': '1420', 'Total Height (mm)': '1600' }
          ],
          'Brine Valve Specifications': [
            { 'Model': '434', 'Tank Range (L)': '60-200L', 'Well Mini. Dia. (mm)': '90' },
            { 'Model': '454', 'Tank Range (L)': '300-2000L', 'Well Mini. Dia. (mm)': '120' },
            { 'Model': '1600', 'Tank Range (L)': '15-200L', 'Well Mini. Dia. (mm)': '40' },
            { 'Model': '1700', 'Tank Range (L)': '300-2000L', 'Well Mini. Dia. (mm)': '95' }
          ]
        }
      }
    };

    export const multiMediaFilterProductsList = [
      {
        id: 'multi-port-manual-softener-valve',
        name: 'Multi-Port Manual Softener Valve',
        category: 'Multi-Media Filter',
        image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/ee6f2886e563c6df35520935aea0208e.png',
        shortDescription: 'Reliable and economical manual control valve for softener and filter systems.',
        description: 'Durable and user-friendly control valve for residential and light commercial water softener and filtration systems.',
        features: [
          'Manual control for easy operation',
          'Suitable for softener and filter applications',
          'Durable,corrosion-resistant materials'
        ],
        applications: [
          'Residential water softeners',
          'Point-of-entry (POE) filtration',
          'Carbon filtration systems'
        ]
      },
      {
        id: 'multi-port-manual-filter-valve',
        name: 'Multi-Port Manual Filter Valve',
        category: 'Multi-Media Filter',
        image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/f39716561652bca664f108991de4184a.jpg',
        shortDescription: 'Versatile manual control valve for various water filtration systems.',
        description: 'A manual multi-port control valve for filter systems,available in multiple configurations to match different housing sizes and flow requirements.',
        features: [
          'Multiple models for different flow capacities',
          'Inlet/Outlet sizes from 1/2" to 2"',
          'Designed to match with standard 10" and 20" filter housings'
        ],
        applications: [
          'Multi-media filtration',
          'Activated carbon filters',
          'Sand filters'
        ]
      },
      {
        id: 'multi-port-automatic-softener-valve',
        name: 'Multi-Port Automatic Softener Valve',
        category: 'Multi-Media Filter',
        image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/694559f5ba74f0d5ed5e6927cd4ffa8c.jpg',
        shortDescription: 'Automatic multi-port control valve for softener systems,ensuring efficient regeneration and reliable operation.',
        description: 'The Multi-Port Automatic Softener Valve offers advanced control for water softening systems,automating the regeneration process for a continuous supply of soft water.',
        features: [
          'Automatic regeneration based on time or flow',
          'Multiple models for various system sizes',
          'Down-Flow and UP-Flow regeneration modes'
        ],
        applications: [
          'Residential water softeners',
          'Commercial water softening systems',
          'Industrial pre-treatment'
        ]
      },
      {
        id: 'multi-port-automatic-filter-valve',
        name: 'Multi-Port Automatic Filter Valve',
        category: 'Multi-Media Filter',
        image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/955495052ec7c622ee10db7becbba261.jpg',
        shortDescription: 'Automatic control valve for filter systems,featuring time-based backwashing for efficient and hassle-free operation.',
        description: 'The Multi-Port Automatic Filter Valve automates the backwash and rinse cycles for filtration systems,ensuring consistent water quality with minimal manual intervention.',
        features: [
          'Automatic backwash based on time',
          'Multiple models for various flow rates',
          'Easy-to-program controller'
        ],
        applications: [
          'Multi-media filtration',
          'Sand filters',
          'Activated carbon filters'
        ]
      },
      {
        id: 'water-distributor',
        name: 'Water Distributor',
        category: 'Multi-Media Filter',
        image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/dbc45b6bfca822250189c396a97aeb0b.jpg',
        shortDescription: 'Essential components designed for uniform flow distribution in media filters and softeners.',
        description: 'Water distributors are crucial for the proper functioning of media filters,ensuring even flow of water through the media bed for optimal performance.',
        features: [
          'Ensures uniform flow distribution',
          'Durable,corrosion-resistant plastic construction',
          'Variety of models for different tank sizes'
        ],
        applications: [
          'Multi-media filters',
          'Water softeners',
          'Sand filters'
        ]
      },
      {
        id: 'frp-tank',
        name: 'Fiberglass Reinforced Plastic (FRP) Tank',
        category: 'Multi-Media Filter',
        image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/5592d07875bc9bafd4fa068fb355983e.jpg',
        shortDescription: 'High-quality fiberglass reinforced plastic tanks for water softeners,filters,and storage.',
        description: 'Durable and corrosion-resistant FRP tanks designed for residential and commercial water treatment applications.',
        features: [
          'Seamless PE or PP inner liner',
          'Fiberglass wound outer shell',
          'Completely rustproof and corrosion-resistant'
        ],
        applications: [
          'Water softeners',
          'Multi-media filters',
          'Carbon filters'
        ]
      },
      {
        id: 'ion-exchange-resin',
        name: 'Ion Exchange Resin',
        category: 'Multi-Media Filter',
        image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/ad5e58c3ec2204eb07497c3d5434b6f7.jpg',
        shortDescription: 'High-quality ion exchange resins for water softening,deionization,and purification.',
        description: 'A range of cation and anion exchange resins for various water treatment applications,including softening,demineralization,and selective ion removal.',
        features: [
          'High-purity,high-capacity resin beads',
          'Effective for water softening and deionization',
          'Excellent chemical and physical stability'
        ],
        applications: [
          'Water softening',
          'Demineralization and deionization',
          'Ultrapure water production'
        ]
      },
      {
        id: 'brine-tank',
        name: 'Brine Tank',
        category: 'Multi-Media Filter',
        image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/f36c496b6a31a4339add144becdec686.jpg',
        shortDescription: 'Durable polyethylene (PE) brine tanks for water softener regeneration, available from 15L to 2000L.',
        description: 'High-quality brine tanks designed for use with water softening systems, holding the salt solution required for resin regeneration.',
        features: [
          'Durable, corrosion-resistant Polyethylene (PE) material',
          'Wide range of capacities (15L to 2000L)',
          'Seamless, one-piece construction'
        ],
        applications: [
          'Residential water softeners',
          'Commercial water softening systems',
          'Industrial water treatment'
        ]
      }
    ];

    export default multiMediaFilterProducts;